import { ref as v, watch as h, createBlock as S, openBlock as n, withCtx as b, createElementVNode as u, normalizeClass as x, createElementBlock as d, createCommentVNode as r, toDisplayString as o, createVNode as s, withModifiers as V } from "vue";
import { validateValue as k } from "../../../../utils/validators/validate.js";
import { useMask as B } from "../../../../utils/masks/mask.js";
import c from "../../icon/marketplaces/ds-atom-icon.js";
import z from "../../form-field/marketplaces/ds-atom-form-field.js";
import '../../../../assets/ds-atom-input.css';const q = {
  key: 0,
  class: "mp-input-element__prefix"
}, w = {
  key: 1,
  class: "mp-input-element__icon"
}, C = ["id", "name", "type", "placeholder", "disabled", "value", "min", "max"], N = {
  key: 2,
  class: "mp-input-element__suffix"
}, $ = {
  key: 3,
  class: "mp-input-element__search",
  type: "submit",
  "aria-label": "Search"
}, F = {
  __name: "ds-atom-input",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "small"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    mask: {
      type: String,
      default: ""
    },
    validation: {
      type: String,
      default: ""
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    }
  },
  emits: ["updateValue", "updateValidation", "blur", "focus"],
  setup(e, { emit: f }) {
    const a = f, l = e, m = v(null), p = (t) => {
      let i = B(l.mask, t.target);
      a("updateValue", i), t.target.value !== i && (t.target.value = i);
    };
    h(() => l.value, (t) => {
      m.value.value = t;
    });
    const y = (t) => {
      const i = k(l.value, l.validation);
      i !== l.isValid && a("updateValidation", i), a("blur", t);
    }, g = (t) => {
      a("updateValidation", null), a("focus", t);
    };
    return (t, i) => (n(), S(z, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: b(() => [
        u("div", {
          class: x([
            "mp-input-element",
            `mp-input-element--type-${e.type}`,
            `mp-input-element--size-${e.size}`,
            {
              "mp-input-element--has-icon": e.icon,
              "mp-input-element--disabled": e.disabled
            }
          ])
        }, [
          e.prefix ? (n(), d("div", q, [
            u("span", null, o(e.prefix), 1)
          ])) : e.icon ? (n(), d("div", w, [
            s(c, {
              icon: e.icon,
              type: "regular",
              size: "auto"
            }, null, 8, ["icon"])
          ])) : r("", !0),
          u("input", {
            id: e.id,
            ref_key: "input",
            ref: m,
            class: "mp-input-element__input",
            name: e.name,
            type: e.type,
            placeholder: e.placeholder,
            disabled: e.disabled,
            value: e.value,
            min: e.min,
            max: e.max,
            onInput: V(p, ["prevent"]),
            onFocus: g,
            onBlur: y
          }, null, 40, C),
          e.suffix ? (n(), d("div", N, [
            u("span", null, o(e.suffix), 1)
          ])) : r("", !0),
          e.type === "search" ? (n(), d("button", $, [
            s(c, {
              icon: "magnifying-glass",
              type: "regular"
            })
          ])) : r("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
};
export {
  F as default
};
